<div class="flex flex-col justify-start items-stretch gap-y-2">
  @if (deliveryItems.isFetching()) {
  <ngx-skeleton-loader appearance="line" count="5"></ngx-skeleton-loader>
  } @else {
  <div class="w-full overflow-x-auto">
    <table class="table">
      <thead>
        <tr>
          <th>Items</th>
        </tr>
      </thead>
      <tbody>
        @for (item of deliveryItems.data()?.deliveryItems; track item.id) {
        <tr>
          <td>
            {{ item.name }}
            @if(item.sourceItem?.item && itemIdsAttributePending().includes(item.id)) {
            <app-tracked-attributes-prompt [attributes]="
                      item.sourceItem?.item.tracked_attributes ??
                      []
                    " [event]="delivery().type" [itemId]="item.sourceItem.item.id" [promptableId]="item.sourceItem.id"
              [itemCode]="item.name" (addedAttributes)="
                    attributesUpdated(item.id)
                    " promptableType="hireItem"></app-tracked-attributes-prompt>
            }
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>

  @if (needsItemsAssigned()) {
  <app-alert-text>
    <div class="flex flex-col w-full text-center items-center justify-start gap-y-4">
      <p>Some items on this delivery have not yet been assigned</p>
      <button mat-flat-button color="primary" (click)="openAssignItemsDialog()">
        Assign Items
      </button>
    </div>
  </app-alert-text>
  } @else {
  <div
    class="flex lg:flex-row md:flex-wrap md:justify-end md:items-center md:gap-4 flex-col justify-start items-stretch w-full gap-y-6">
    @if (canUpdateItems()) {
    <button mat-stroked-button (click)="openAssignItemsDialog()">
      Update Items
    </button>
    }

    <button mat-stroked-button color="primary" (click)="openSignatureCaptureDialog()">
      Capture Signature
    </button>
    @if(delivery().fulfilled_date === null) {
    <button mat-flat-button color="primary" (click)="completeDelivery()">
      Complete Job
    </button>
    }
  </div>
  }
  }
</div>